import React from "react";
import Edit from "../../../components/CRM/Edit";
import {
  SimpleForm,
  TextField,
  LongTextInput,
  translate,
} from "admin-on-rest";
import {connect} from "react-redux";
import {formStyle} from "./style";
import Interpolations from "../../../components/Interpolations";
 
const MessageTemplateTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.messageTemplates.titleEdit")} {record ? `${record.name}` : ""}
    </span>
  );
};

const MessageTemplateTitle = translate(MessageTemplateTitleBase);

class MessageTemplateEditForm extends React.Component {
 
  render() {
    const props = {...this.props};

    const {configuration} = props;

    const has_cashbacker = configuration.instance ? configuration.instance.has_cashbacker : false;

    const extraInstructions = has_cashbacker ? [[".Cashbacker.SignupUrl", ".Cashbacker.TosText"]] : [];
    
    const interpolations = extraInstructions.concat([
      [".Customer.FirstName", ".Customer.LastName", ".Customer.Phone", ".Customer.Email"],
      [".Owner.FirstName", ".Owner.LastName", ".Owner.Email"],
      [".Store.Name", ".Store.SMSSender", ".Store.FullUrl"]
    ]);

    return (
      <Edit title={<MessageTemplateTitle />} {...props}>
        <SimpleForm>
            <TextField
              label="resources.messageTemplates.inputs.name"
              source="name"
            />
            <TextField
              label="resources.messageTemplates.inputs.description"
              source="description"
            />
            <LongTextInput
              label="resources.messageTemplates.inputs.smsContent"
              source="sms_content"
            />
            <Interpolations interpolations={interpolations}/>
        </SimpleForm>
      </Edit>
    );
  }
}

const mapStateToProps = (state, props) => ({
  id: decodeURIComponent(props.match.params.id),
  configuration: state.configuration,
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null
});

export default connect(mapStateToProps)(translate(MessageTemplateEditForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/MessageTemplates/MessageTemplateEditForm.js